<template>
  <div>
    <div class="platform_header">
      <div class="left-header">
          <img style="width: 44px; margin-right: 12px" src="@/assets/img/icon-logo.png" />
          <span class="header-title">辽宁省政府采购协会</span>
      </div>
      <div class="right-header">

      </div>
    </div>
    <el-form label-width="120px" :rules="rules" :model="dataForm" ref="dataForm" style="width: 600px; margin: 60px auto">
      <el-form-item label="专家姓名：" prop="name" :rules="[{ required: true, message: '专家姓名不能为空'}]">
        <el-input placeholder="请输入专家姓名" v-model="dataForm.name"></el-input>
      </el-form-item>
      <el-form-item label="证件号码：" prop="idcard" :rules="[{ required: true, message: '证件号码不能为空'}]">
        <el-input maxlength="18" placeholder="请输入证件号码" v-model="dataForm.idcard" class="input-with-select">
          <el-select style="width: 120px" v-model="dataForm.idType" slot="prepend" placeholder="请选择">
            <el-option label="身份证" value="0"></el-option>
            <el-option label="军人证" value="1"></el-option>
            <el-option label="护照" value="2"></el-option>
          </el-select>
        </el-input>
      </el-form-item>
      <el-form-item label="常住地：" prop="regionalismList" :rules="[{ required: true, message: '常住地不能为空'}]">
        <el-cascader
          style="width: 100%"
          v-model="dataForm.regionalismList"
          placeholder="请选择"
          :options="citys"
          :props="{ label: 'codeName', value: 'codeName' }"
          filterable>
        </el-cascader>
      </el-form-item>
      <el-form-item label="详细地址：" prop="homeaddress" :rules="[{ required: true, message: '详细地址不能为空'}]">
        <el-input v-model="dataForm.homeaddress" placeholder="请输入详细地址"></el-input>
      </el-form-item>
      <el-form-item label="手机号：" prop="phonenumbers" :rules="[{ required: true, message: '手机号不能为空'}]">
        <el-input v-model="dataForm.phonenumbers" placeholder="请输入手机号"></el-input>
        <div class="tip">注：此手机号码为找回账号密码的唯一途径，请妥善保管。</div>
      </el-form-item>
      <!-- canvas图形验证码输入框 -->
      <el-form-item v-if="sysConfig.value == '1'" label="验证码：" prop="authCode" :rules="[{ required: true, message: '验证码不能为空'}]">
        <el-input style="width: 70%;" v-model="dataForm.authCode" placeholder="请输入验证码"></el-input>
          <el-button v-if="!state.showTime" style="margin-left: 10px;" type="primary" plain @click="sendSms">发送验证码</el-button>
          <el-button v-else style="margin-left: 10px;" type="primary" plain disabled>已发送({{ state.time }}s)</el-button>
      </el-form-item>
      <el-form-item label="登录密码：" prop="passWord">
        <el-input type="password" v-model="dataForm.passWord" autocomplete="off" placeholder="请输入登录密码"></el-input>
        <div class="tip">注：密码必须由字母、数字组成，长度在8-20之间</div>
      </el-form-item>
      <el-form-item label="确认密码：" prop="comPass">
        <el-input type="password" v-model="dataForm.comPass" autocomplete="off" placeholder="请输入确认密码"></el-input>
      </el-form-item>
      <el-form-item label="电子邮箱：" prop="email" :rules="[{ required: true, message: '电子邮箱不能为空'}]">
        <el-input type="email" v-model="dataForm.email" autocomplete="off" placeholder="请输入电子邮箱"></el-input>
      </el-form-item>
      <el-form-item label="资料下载：" >
        <el-button type="text" @click="downLoad(1)">辽宁省政府采购评审专家承诺书.doc</el-button>
        <br />
        <el-button type="text" @click="downLoad(2)">辽宁省政府采购评审专家申请书.doc</el-button>
      </el-form-item>

      <el-checkbox v-model="checked">已阅读关于印发《辽宁省政府采购协会专家管理办法》</el-checkbox><el-button type="text" @click="dialog_info_Visible = true">点击链接查看</el-button>
      <div style="margin-top: 20px; text-align: right">
        <el-button @click="goBack">取消</el-button>
        <el-button :disabled="!checked" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>


    <el-dialog title="《辽宁省政府采购协会专家管理办法》" :visible.sync="dialog_info_Visible" width="60%">
      <div >
        <div>
          <div style="font-size: 16px;">
            <p style="text-align: center; font-size: 24px;">
              <strong>辽宁省政府采购评审专家管理办法</strong>
            </p>
            <p style="text-align: center; font-size: 20px; margin: 20px 0px 30px;">
              <strong>第一章 总 则</strong>
            </p>
            <div class="tiao">
              <strong>第一条</strong> 为加强全省政府采购评审活动管理，规范政府采购评审专家（以下简称评审专家）评审行为，根据《中华人民共和国政府采购法》（以下简称《政府采购法》）、《中华人民共和国政府采购法实施条例》（以下简称《政府采购法实施条例》）和财政部《政府采购评审专家管理办法》等法律法规及有关规定，结合我省实际制定本办法。
            </div>
            <div class="tiao">
              <strong>第二条</strong> 本办法所称评审专家，是指经省财政厅选聘，以独立身份参加政府采购评审活动，纳入“辽宁省政府采购评审专家库”管理的人员。评审专家选聘、解聘、抽取、使用、监督管理适用本办法。
            </div>
            <div class="tiao">
              <strong>第三条</strong> 评审专家实行统一标准、管用分离、随机抽取的管理原则。
            </div>
            <div class="tiao">
              <strong>第四条</strong> 省财政厅按照财政部制定的全国统一的评审专家专业分类标准和评审专家库建设标准，建设全省统一的评审专家库并实行动态管理，与国家评审专家库互联互通、资源共享。负责依法制定评审专家管理制度；评审专家管理系统的建设和维护管理；组织评审专家的网上培训；评审专家的选聘、解聘审核。
            </div>
            <div class="tiao"> 各设区的市财政部门（以下简称各市财政局）负责本地区评审专家的征集以及选聘、解聘的初审工作。
              <br>
            </div>
            <div class="tiao">各级人民政府财政部门依法履行对评审专家的监督管理职责。</div>
            <p style="text-align: center; font-size: 20px; margin: 20px 0px 30px;">
              <strong>第二章 评审专家选聘与解聘</strong>
            </p>
            <div class="tiao">
              <strong>第五条</strong> 评审专家的选聘通过公开征集、单位推荐和自我推荐相结合的方式进行。
            </div>
            <div class="tiao">
              <strong>第六条</strong> 评审专家应当具备以下条件： 
            </div>
            <div class="tiao1">
              <div>（一）具有良好的职业道德，廉洁自律，遵纪守法，无行贿、受贿、欺诈等不良信用记录；</div>
              <div>（二）具有中级专业技术职称或同等专业水平且从事相关领域工作满8年，或者具有高级专业技术职称或同等专业水平；</div>
              <div>（三）熟悉政府采购相关政策法规；</div>
              <div>（四）承诺以独立身份参加评审工作，依法履行评审专家工作职责并承担相应法律责任的中国公民；</div>
              <div>（五）不满70周岁，身体健康，能够承担评审工作；</div>
              <div>（六）申请成为评审专家前三年内，无本办法第四十一条规定的不良行为记录。</div>
              <div>对评审专家数量较少的专业，前款第（二）项、第（五）项所列条件可以适当放宽。</div>
            </div>
            <div class="tiao">
              <strong>第七条</strong> 符合本办法第五条、第六条规定，申请成为评审专家的人员应通过辽宁政府采购网“www.ccgp-liaoning.gov.cn”评审专家管理系统在线填报相关信息，扫描上传以下申请材料：
            </div>
            <div class="tiao1">
              <div>（一）个人简历、本人签署的申请表和承诺书（见附件1、附件2）；</div>
              <div>（二）学历学位证书、专业技术职称证书或者具有同等专业水平的证明材料；</div>
              <div>（三）证明本人身份的有效证件；</div>
              <div>（四）本人认为需要申请回避的信息；</div>
              <div>（五）省财政厅规定的其他材料。</div>
            </div>
            <div class="tiao">
              <strong>第八条</strong> 申请人应当根据本人专业或专长申报评审专业。申请人只能从经济类、法律类、技术类三个大类中选择其一，技术类申报不得超过三个相关专业。
            </div>
            <div class="tiao">
              <strong>第九条</strong> 申请人在网上登记注册后，各市财政局应于5个工作日内通过辽宁政府采购网评审专家管理系统对本地区申请人提交的申请材料、申报的评审专业和信用信息进行审核，按照“择优选聘”的原则提出初审意见。
            </div>　 <div class="tiao">
              <strong>第十条</strong> 省财政厅根据各市财政局的初审意见对申请人相关信息进行复核，符合条件的选聘为评审专家，纳入评审专家库管理。
            </div>
            <div class="tiao">
              <strong>第十一条</strong> 评审专家的选聘来源以高等院校、科研机构、专业部门等单位工作的人员为主。
            </div>
            <div class="tiao">
              <strong>第十二条</strong> 评审专家工作单位、联系方式、专业技术职称、需要回避的信息等发生变化的，应当及时在辽宁政府采购网评审专家管理系统向省财政厅申请变更相关信息。
            </div>
            <div class="tiao">
              <strong>第十三条</strong> 评审专家存在以下情形之一的，省财政厅将予以解聘： 
            </div>
            <div class="tiao1">
              <div>（一）不符合本办法第六条规定条件；</div>
              <div>（二）本人申请不再担任评审专家；</div>
              <div>（三）存在本办法第四十一条规定的不良行为记录；</div>
              <div>（四）受到刑事处罚；</div>
              <div>（五）一年内同意接受评审任务后，无故不参加评审活动达到2次的；</div>
              <div>（六）一年内在抽取过程中拒绝参加评审活动达到10次的；</div>
              <div>（七）一年内职责履行情况记录为“差”达到3次的；</div>
              <div>（八）法律法规规定的其他情形。</div>
            </div>
            <div class="tiao">
              <strong>第十四条</strong> 各市财政局在工作中发现评审专家存在本办法第十三条情形之一的，应提出解聘意见并上传相关资料，报省财政厅批准。
            </div>
            <p style="text-align: center; font-size: 20px; margin: 20px 0px 30px;">
              <strong>第三章 评审专家抽取与使用</strong>
            </p>
            <div class="tiao">
              <strong>第十五条</strong> 申请人被选聘为评审专家后，应接受在线政府采购政策法规培训和测试。通过测试后，方能参与政府采购评审活动。
            </div>
            <div class="tiao">
              <strong>第十六条</strong> 按照“谁组织实施，谁负责抽取”的原则，采购人或采购代理机构通过辽宁政府采购网及各市分网在辽宁省政府采购评审专家库抽取评审专家。评审专家抽取采用全省统一号码、网上随机抽取、语音自动通知。
            </div>
            <div class="tiao">
              <strong>第十七条</strong> 采购人或采购代理机构应当在评审活动开始前，根据采购项目需求，合理提出评标委员会、询价小组、谈判小组、磋商小组（以下统称评审委员会）组成条件，其中由代理机构组织实施的项目，须由采购人进行确认。
            </div>
            <div class="tiao">
              <strong>第十八条</strong> 评审专家库中相关专业专家数量不能保证随机抽取需要的，采购人或者采购代理机构可以推荐符合条件的人员，经审核选聘入库后再随机抽取使用。
            </div>
            <div class="tiao">
              <strong>第十九条</strong> 技术复杂、专业性强的采购项目，通过随机方式难以确定合适评审专家的，经主管预算单位同意，采购人可以自行选定相应专业领域的评审专家。
            </div>
            <div class="tiao">
              <strong>第二十条</strong> 高等院校和科研院所科研仪器设备采购，可在政府采购评审专家库外自行选择评审专家，但所选的评审专家应当符合本办法第六条规定的条件。
              <br>
            </div>
            <div class="tiao">
              <strong>第二十一条</strong> 除采用竞争性谈判、竞争性磋商方式采购，以及异地评审的项目外，采购人或者采购代理机构抽取评审专家的开始时间应当在评审活动开始前1个工作日，特殊情况不得超过2个工作日
            </div>
            <div class="tiao">
              <strong>第二十二条</strong> 采购人或者采购代理机构应当在评审活动开始前核实评审专家身份，宣布评审工作纪律，并将记载评审工作纪律的书面文件一并存档。
            </div>
            <div class="tiao">
              <strong>第二十三条</strong> 评审专家与参加采购活动的供应商存在下列利害关系之一的，应当回避：
            </div>
            <div class="tiao1">
              <div>（一）参加采购活动前三年内，与供应商存在劳动关系，或者担任过供应商的董事、监事，或者是供应商的控股股东或实际控制人；</div>
              <div>（二）与供应商的法定代表人或者负责人有夫妻、直系血亲、三代以内旁系血亲或者近姻亲关系；</div>
              <div>（三）与供应商有其他可能影响政府采购活动公平、公正进行的关系。</div>
              <div>评审专家发现本人与参加采购活动的供应商有利害关系的，应当主动提出回避。采购人或者采购代理机构发现评审专家与参加采购活动的供应商有利害关系的，应当要求其回避。</div>
            </div>
            <div class="tiao">
              <strong>第二十四条</strong> 采购人或采购代理机构就采购文件征询过其意见或已参加过项目前期论证活动的评审专家，不得参与同一项目的采购评审工作。
            </div>
            <div class="tiao">
              <strong>第二十五条</strong> 除本办法第十九条规定的情形外，评审专家对本单位的政府采购项目只能作为采购人代表参与评审活动。
            </div>
            <div class="tiao">
              <strong>第二十六条</strong> 采购代理机构工作人员不得以评审专家身份参加由本机构代理的政府采购项目评审活动。
            </div>
            <div class="tiao">
              <strong>第二十七条</strong> 各级财政部门政府采购监督管理工作人员，不得作为评审专家参与政府采购项目的评审活动。
            </div>
            <div class="tiao">
              <strong>第二十八条</strong> 出现评审专家缺席、回避等情形导致评审现场专家数量不符合规定的，采购人或者采购代理机构应当及时补抽评审专家，或者经采购人主管预算单位同意自行选定补足评审专家。无法及时补足评审专家的，采购人或者采购代理机构应当立即停止评审工作，妥善保存采购文件，依法重新组建评审委员会进行评审。
            </div>
            <div class="tiao">
              <strong>第二十九条</strong> 评审专家应当严格遵守评审工作纪律，按照客观、公正、审慎的原则，根据采购文件规定的评审程序、评审方法和评审标准进行独立评审。
            </div>
            <div class="tiao"> 评审专家发现采购文件内容违反国家有关强制性规定或者采购文件存在歧义、重大缺陷导致评审工作无法进行时，应当停止评审并向采购人或者采购代理机构书面说明情况。 </div>
            <div class="tiao"> 评审专家应当配合答复供应商的询问、质疑和投诉等事项,不得泄露评审文件、评审情况和在评审过程中获悉的商业秘密。 </div>
            <div class="tiao"> 评审专家发现供应商具有行贿、提供虚假材料或者串通等违法行为的，应当及时向财政部门报告。评审专家在评审过程中受到非法干预的，应当及时向财政、监察等部门举报。 </div>
            <div class="tiao">
              <strong>第三十条</strong> 评审专家应当在评审报告上签字，对自己的评审意见承担法律责任。对需要共同认定的事项存在争议的，按照少数服从多数的原则做出结论。对评审报告有异议的，应当在评审报告上签署不同意见并说明理由，否则视为同意评审报告。
            </div>
            <div class="tiao">
              <strong>第三十一条</strong> 评审专家名单在评审结果公告前应当保密。评审活动完成后，采购人或者采购代理机构应当随中标、成交结果一并公告评审专家名单，并对自行选定的评审专家做出标注。
            </div>
            <div class="tiao">
              <strong>第三十二条</strong> 采购人或者采购代理机构应当于评审活动结束后5个工作日内，在辽宁政府采购网及各市分网中记录评审专家的职责履行情况。要对评审专家的专业技术水平、职业道德素质和评审工作等情况进行评价。省财政厅将另行制定评审专家履职评价标准。
            </div>
            <div class="tiao">
              <strong>第三十三条</strong> 评审专家可以在政府采购信用评价系统中查询本人职责履行情况记录，并就有关情况作出说明。省财政厅根据评审专家履职情况等因素设置阶梯抽取概率。
            </div>
            <div class="tiao">
              <strong>第三十三条</strong> 评审专家应当于评审活动结束后5个工作日内，在辽宁政府采购网中记录采购人或者采购代理机构的职责履行情况。
            </div>
            <p style="text-align: center; font-size: 20px; margin: 20px 0px 30px;">
              <strong>第四章 评审专家劳务报酬</strong>
            </p>
            <div class="tiao">
              <strong>第三十四条</strong> 评审工作完成后，集中采购机构或采购人应按规定向评审专家支付劳务报酬和异地评审差旅费。
            </div>
            <div class="tiao">
              <strong>第三十五条</strong> 对于集中采购机构操作的项目，由集中采购机构支付评审专家劳务报酬。对于社会代理机构或采购人自行操作的项目，由采购人支付评审专家劳务报酬。支付方式可由采购人直接支付，也可先由社会代理机构垫付，采购人与其进行结算。采购人或采购代理机构凭《辽宁省政府采购评审专家劳务报酬确认表》（见附件3），按标准向评审专家支付劳务报酬。
            </div>
            <div class="tiao">
              <strong>第三十六条</strong> 政府采购项目评审专家劳务报酬标准：2小时以内300元/人，每增加1小时增加100元/人，每天最高不超过800元/人；担任评审委员会组长的专家增发100元/人；评审专家到达评审现场后项目未进行评审或因回避等原因未参与评审的100元/人；项目进入评审程序后中止评审的，按实际评审时间计算；评审专家迟到30分钟以上的，扣劳务报酬100元/人。各级财政部门可根据本地经济发展水平适当调整评审专家劳务报酬标准。
            </div>
            <div class="tiao">
              <strong>第三十七条</strong> 评审专家在省内参加异地评审的，其往返的城市间交通费、住宿费等实际发生的费用，可参照采购人执行的差旅费管理办法相应标准向采购人或集中采购机构凭据报销。技术条件复杂的政府采购项目，在辽宁省政府采购专家库中的专家不能满足需要的前提下，可以聘请省外专家参加评审，所发生的交通费、食宿费和评审劳务报酬可由双方协商确定。
            </div>
            <div class="tiao">
              <strong>第三十八条</strong> 评审专家未完成评审工作擅自离开评审现场，或者在评审活动中有违法违规行为的，不得获取劳务报酬和报销异地评审差旅费。评审专家以外的其他人员不得获取评审劳务报酬。
            </div>
            <p style="text-align: center; font-size: 20px; margin: 20px 0px 30px;">
              <strong>第五章 评审专家监督管理</strong>
            </p>
            <div class="tiao">
              <strong>第三十九条</strong> 评审专家未按照采购文件规定的评审程序、评审方法和评审标准进行独立评审或者泄露评审文件、评审情况的，由财政部门给予警告，并处2000元以上2万元以下的罚款；影响中标、成交结果的，处2万元以上5万元以下的罚款，禁止其参加政府采购评审活动。
            </div>
            <div class="tiao"> 评审专家与供应商存在利害关系未回避的，处2万元以上5万元以下的罚款，禁止其参加政府采购评审活动。 </div>
            <div class="tiao"> 评审专家收受采购人、采购代理机构、供应商贿赂或者获取其他不正当利益，构成犯罪的，依法追究刑事责任；尚不构成犯罪的，处2万元以上5万元以下的罚款，禁止其参加政府采购评审活动。 </div>
            <div class="tiao"> 评审专家有上述违法行为的，其评审意见无效；有违法所得的，没收违法所得；给他人造成损失的，依法承担民事责任。 </div>
            <div class="tiao">
              <strong>第四十条</strong> 采购人、采购代理机构发现评审专家有违法违规行为的，应当及时向本级财政部门报告。
            </div>
            <div class="tiao">
              <strong>第四十一条 </strong>申请人或评审专家有下列情形的，列入不良行为记录：
            </div>
            <div class="tiao1">
              <div>（一）未按照采购文件规定的评审程序、评审方法和评审标准进行独立评审；</div>
              <div>（二）泄露评审文件、评审情况；</div>
              <div>（三）与供应商存在利害关系未回避；</div>
              <div>（四）收受采购人、采购代理机构、供应商贿赂或者获取其他不正当利益；</div>
              <div>（五）提供虚假申请材料；</div>
              <div>（六）拒不履行配合答复供应商询问、质疑、投诉等法定义务；</div>
              <div>（七）以评审专家身份从事有损政府采购公信力的活动。</div>
            </div>
            <div class="tiao">
              <strong>第四十二条</strong> 采购人或者采购代理机构未按照本办法规定抽取和使用评审专家的，依照《政府采购法》及有关法律法规追究法律责任。
            </div>
            <div class="tiao">
              <strong>第四十三条</strong> 财政部门工作人员在评审专家管理工作中存在滥用职权、玩忽职守、徇私舞弊等违法违纪行为的，依照《政府采购法》《公务员法》《行政监察法》《政府采购法实施条例》等国家有关规定追究相应责任；涉嫌犯罪的，移送司法机关处理。
            </div>
            <p style="text-align: center; font-size: 20px; margin: 20px 0px 30px;">
              <strong>第六章 附　则</strong>
            </p>
            <div class="tiao">
              <strong>第四十四条</strong> 参加评审活动的采购人代表、采购人依法自行选定的评审专家管理参照本办法执行。
            </div>
            <div class="tiao">
              <strong>第四十五条</strong> 国家对评审专家抽取、选定另有规定的，从其规定。
            </div>
            <div class="tiao">
              <strong>第四十六条</strong> 本办法所称主管预算单位是指负有编制部门预算职责，向本级财政部门申报预算的国家机关、事业单位和团体组织。
            </div>
            <div class="tiao">
              <strong>第四十七条</strong> 本办法由辽宁省财政厅负责解释。
              <br>
            </div>
            <div class="tiao">
              <strong>第四十八条</strong> 本办法自2018年1月1日起施行。《辽宁省省直政府采购评审专家使用管理暂行办法》（辽财采〔2010〕1102号）和《辽宁省省直政府采购评审专家劳务费支付标准（试行）》（辽财采〔2013〕834号）同时废止。
            </div>
            <div style="margin-left: 20px;margin-top: 5px;">附件：1.辽宁省政府采购评审专家申请书</div>
            <div style="margin-left: 63px;">2.辽宁省政府采购评审专家承诺书</div>
            <div style="margin-left: 63px;">3.辽宁省政府采购评审专家劳务报酬确认表</div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button plain size="small" @click="dialog_info_Visible = false,checked = true">关  闭</el-button>
      </span>
    </el-dialog>

    <!-- canvas图形验证码弹窗 -->
    <el-dialog :visible.sync="dialog_code_Visible" width="30%">
      <div>
        验证码：<el-input v-model="state.inCode" style="width: 40%" type="email" placeholder="请输入验证码" @keyup.enter.native="sendSmsCode" ></el-input>
        <canvas width="100" height="30" @click="handleDrawCode" ref="canvasRef"></canvas>
      </div>
      
      <span slot="footer" class="dialog-footer">
        <el-button plain size="small" type="success" @click="sendSmsCode">确  认</el-button>
        <el-button plain size="small" @click="dialog_code_Visible = false">关  闭</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
import { prefixedUrlAsset } from '@/utils/constants';
export default ({
  data() {
    var validatePass = (rule, value, callback) => {
      const reg =/^(?=.*[a-zA-Z])(?=.*[0-9])[A-Za-z0-9]{8,20}$/;
      if (!reg.test(value)) {
        callback(new Error('密码必须由字母、数字组成，长度在8-20之间'))
      } else {
        callback();
      }
    };
    var validateComPass = (rule, value, callback) => {
      if (value !== this.dataForm.passWord) {
        callback(new Error('确认密码与登录密码不一致'))
      } else {
        callback();
      }
    };
    return {
      rules: {
        passWord: [
          { required: true, message: '登录密码不能为空', trigger: 'blur' },
          { validator: validatePass, trigger: 'change' }
        ],
        comPass: [
          { required: true, message: '确认密码不能为空'},
          { validator: validateComPass, trigger: 'blur' }
        ],
      },
      dataForm: {
        idType: '0'
      },
      citys: [],
      checked: false,
      loading: false,
      dialog_info_Visible: false,
      dialog_code_Visible: false,
      // canvas图形验证码参数
      state: {
        showCode: '',
        inCode: '',
        time: 60,
        showTime: false,
      },
      sysCode: 'zj_register',
      sysConfig: {},
    }
  },
  created() {
    this.axios.get(`${prefixedUrlAsset}/api/expert/getXzqh`).then((({ data })=> {
        if (data.code == 200) {
          this.citys = data.data;
        } else {
          this.$message.warning(data.msg)
        }
    }))
    this.axios.get(`${prefixedUrlAsset}/pub/sysConfig/info/${this.sysCode}`).then((({ data })=> {
        if (data.code == 0) {
          this.sysConfig = data.data;
        } else {
          this.$message.warning(data.msg)
        }
    }))
  },
  methods: {
    onSubmit() {
      let that = this;
      if(that.dataForm.idType == 0){
        // 身份证验证
        console.log('身份证hao验证====',that.dataForm);
        if (!this.isIdentityId(that.dataForm.idcard)) {
          this.$message.error('身份证号码格式不正确');
          return;
        }
      }else{
        if(that.dataForm.idcard.length < 6){
          this.$message.error('证件号码不能少于6位');
          return;
        }
      }
      
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const {passWord} = this.dataForm;

          const passWordBase64 = window.btoa(passWord)
          const params = {
            ...this.dataForm,
            passWord: passWordBase64,
            sysCode: this.sysCode,
          }
          delete params.comPass;
          this.loading = true;
          this.axios.post(`${prefixedUrlAsset}/api/expert/saveExpertArc`, params).then((({ data })=> {
            this.loading = false;
            if (data.code == 200) {
              this.$alert(`<p>登录账号：${this.dataForm.phonenumbers}</p><p>请使用该账号及注册密码登录，进行信息维护`, '您已注册成功', {
                confirmButtonText: '确定',
                dangerouslyUseHTMLString: true,
                callback: action => {
                  window.open('/gpassoc-admin/#/zjLogin');
                }
              });
            } else {
                this.$message.warning(data.msg)
              }
          }))
        }
      })
    },
    goBack() {
      window.history.back();
    },
    downLoad(type){
      if(type == 1){
        window.open(`http://218.60.151.59:9004/lnnew/M00/00/43/oYYBAFz42F2AQwmPAABwANyf7wg410.doc?token=60d07e9b144e10ad57f9b7d79c29f7c1&t=1714013647435&y=p&filename=辽宁省政府采购评审专家承诺书.doc`)
      }else if(type == 2){
        window.open(`http://218.60.151.59:9004/lnnew/M00/00/43/oYYBAFz42OWAeuk6AACGANwLI8c572.doc?token=d8f1a309998be05d988d36a294de867e&t=1714013595772&y=p&filename=辽宁省政府采购评审专家申请书.doc`)
      }
    },

    // canvas图形验证码生成
    handleDrawCode(){
      let sCode = "A,H,P,D";
      this.axios.get(`${prefixedUrlAsset}/api/auth/showCode?phone=${this.dataForm.phonenumbers}`).then((({ data })=> {
          if (data.code == 0) {
            sCode = data.data;
            this.handleDrawCodeBase(sCode);
          } else {
            this.$message.warning(data.msg)
          }
      }))
    },
    // canvas图形验证码生成
    handleDrawCodeBase(sCode){
      console.log('handleDrawCodeBase',sCode);
      this.state.showCode = ''
      const canvas_width = "150";
      const canvas_height = "40";
      const canvas = this.$refs.canvasRef;//获取canvas
      const context = canvas.getContext("2d");//获取到canvas画图的环境
      canvas.width = canvas_width;
      canvas.height = canvas_height;
      const aCode = sCode.split(",");
      const aLength = aCode.length;//获取到数组的长度
      for (let i = 0; i < 4; i++) { //这里的for循环可以控制验证码位数
        // const j = Math.floor(Math.random() * aLength);//获取到随机的索引值
        const deg = Math.random() - 0.5; //产生一个随机弧度
        const txt = aCode[i];//得到随机的一个内容
        this.state.showCode += txt;//将内容添加到验证码字符串中
        const x = 20 + i * 30;//文字在canvas上的x坐标
        const y = 20 + Math.random() * 8;//文字在canvas上的y坐标
        context.font = "bold 1.5rem 微软雅黑";
        context.translate(x, y);
        context.rotate(deg);
        context.fillStyle = this.getColor();
        context.fillText(txt, 0, 0);
        context.rotate(-deg);
        context.translate(-x, -y);
      }
      for (var i = 0; i <= 5; i++) { //验证码上显示线条
        context.strokeStyle = this.getColor();
        context.beginPath();
        context.moveTo(Math.random() * canvas_width, Math.random() * canvas_height);
        context.lineTo(Math.random() * canvas_width, Math.random() * canvas_height);
        context.stroke();
      }
      for (let i = 0; i <= 20; i++) { //验证码上的小点
        context.strokeStyle = this.getColor();//随机生成
        context.beginPath();
        const x = Math.random() * canvas_width;
        const y = Math.random() * canvas_height;
        context.moveTo(x, y);
        context.lineTo(x + 1, y + 1);
        context.stroke();
      }
    },
    // canvas图形验证码随机颜色
    getColor(){
      const r = Math.floor(Math.random() * 256);
      const g = Math.floor(Math.random() * 256);
      const b = Math.floor(Math.random() * 256);
      return "rgb(" + r + "," + g + "," + b + ")";
    },
    sendSms(){
      if(this.dataForm.phonenumbers == '' || this.dataForm.phonenumbers == null){
        this.$message.warning('手机号不能为空')
        return;
      }else if(this.dataForm.phonenumbers.length != 11){
        this.$message.warning('手机号格式不正确')
        return;
      }
      this.state.inCode = ''
      this.dialog_code_Visible = true;
      this.$nextTick(() => {
        this.handleDrawCode();
      });
    },
    sendSmsCode(){
      if(this.state.inCode == '' || this.state.inCode == null){
        this.$message.warning('验证码不能为空')
        return;
      }
      if(this.state.inCode.toLowerCase() !== this.state.showCode.toLowerCase()){
        this.$message.warning('验证码错误')
        return;
      }
      this.axios.get(`${prefixedUrlAsset}/api/auth/sms?phone=${this.dataForm.phonenumbers}&code=${this.sysCode}&showCode=${this.state.inCode.toLowerCase()}`).then((({ data })=> {
          if (data.code == 0) {
            this.$message.success('验证码发送成功')
            this.state.inCode = ''
            this.dialog_code_Visible = false;
            this.setSendTime(60);
          } else {
            this.$message.warning(data.msg)
          }
      }))
      
    },
    setSendTime(time){
      if(time && time > 0){
        this.state.showTime = true;
        this.state.time = time;
        setTimeout(() => {
          this.setSendTime(time - 1);
        }, 1000);
      }else{
        this.state.showTime = false;
      }
    },
    isIdentityId(identityId) {
      console.log('isIdentityId=====',identityId);
      var patrn = /(^\d{15}$)|(^\d{17}(\d|X|x)$)/;//长度或格式校验
      //地区校验
      var aCity = {
        11: "北京",
        12: "天津",
        13: "河北",
        14: "山西",
        15: "内蒙古",
        21: "辽宁",
        22: "吉林",
        23: "黑龙江",
        31: "上海",
        32: "江苏",
        33: "浙江",
        34: "安徽",
        35: "福建",
        36: "江西",
        37: "山东",
        41: "河南",
        42: "湖北",
        43: "湖南",
        44: "广东",
        45: "广西",
        46: "海南",
        50: "重庆",
        51: "四川",
        52: "贵州",
        53: "云南",
        54: "西藏",
        61: "陕西",
        62: "甘肃",
        63: "青海",
        64: "宁夏",
        65: "新疆",
        71: "台湾",
        81: "香港",
        82: "澳门",
        91: "国外"
      };
      // 出生日期验证
      var sBirthday = (
        identityId.substr(6, 4) +
        "-" +
        Number(identityId.substr(10, 2)) +
        "-" +
        Number(identityId.substr(12, 2))
      ).replace(/-/g, "/"),
        d = new Date(sBirthday)
      // 身份证号码校验 最后4位  包括最后一位的数字/字母X
      var sum = 0,
        weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2],
        codes = "10X98765432";
      for (var i = 0; i < identityId.length - 1; i++) {
        sum += identityId[i] * weights[i];
      }
      var last = codes[sum % 11]; //计算出来的最后一位身份证号码
    
      var isTrue = true;
      if (identityId === '') {
        isTrue = false;
      } else if (!patrn.exec(identityId)) {
        isTrue = false;
      } else if (!aCity[parseInt(identityId.substr(0, 2))]) {
        isTrue = false;
      } else if (sBirthday != d.getFullYear() + "/" + (d.getMonth() + 1) + "/" + d.getDate()) { errorMsg = "身份证上的出生日期非法" } else if (identityId[identityId.length - 1] != last) {
        isTrue = false;
      }
      return isTrue;
    },
  }
})
</script>

<style scoped lang="scss">
  ::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #666 !important;
  }
  .tip {
    color: #666;
  }
  .tiao strong{
    margin-left: 20px;
  }
  .tiao1 div{
    margin-left: 20px;
  }
  .platform_header {
      height: 100px;
      display: flex;
      align-items: center;
      // background: #F8F8F8;
      justify-content: space-between;
      .header-title {
        font-size: 24px;
        font-weight: 700;
        color: #006117;
      }
      .left-header, .right-header {
        display: flex;
        align-items: center;
      }
    }
    // canvas图形验证码
    canvas {
      width: 150px;
      height: 40px;
      margin-left: 20px;
      vertical-align: middle;
      /*vertical-align属性设置一个元素的垂直对齐。*/
      box-sizing: border-box;
      border: 1px solid #ddd;
      cursor: pointer;
      background-color: #eee;
    }
</style>

